import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiserviceService } from '../apiservice.service';



@Component({
  selector: 'app-tvdetails',
  templateUrl: './tvdetails.component.html',
  styleUrls: ['./tvdetails.component.scss']
})
export class TvdetailsComponent implements OnInit {


  coverPrefix:string="https://image.tmdb.org/t/p/original/"
  imgPrefix:string="https://image.tmdb.org/t/p/w500";
  movieId:any=527774
  
  
  
  youtubeKey:any;
  url:any;
  
  
  
  tvshowdetails:any ={}
  details:any;
  
  
  cast:any[]=[];
  



  constructor(private _ActivatedRoute:ActivatedRoute ,private  _ApiserviceService:ApiserviceService) {

    this.movieId=this._ActivatedRoute.snapshot.paramMap.get("id")


  // Details

      this.details=_ApiserviceService.getTvShowDetails(this.movieId).subscribe((data)=>{ this.tvshowdetails= data })



//youtube link

     this._ApiserviceService.getTvYoutubeLink(this.movieId).subscribe((data)=>{
     this.youtubeKey=data.results[0].key
     this.url="https://www.youtube.com/embed/"+this.youtubeKey
     })


//Cast 
      
     this._ApiserviceService.getTvCast(this.movieId).subscribe((data)=>{

      this.cast=data.cast.slice(0, 6)    
     
    })
   }


  ngOnInit(): void {
  }

}
